import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise num
    unit: "Unit 6",
    id: "SB3-U6-P40-E1",
    audio: "img/FriendsPlus/Page40/Audio/audio-e1-p40.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        { url: "img/FriendsPlus/Page40/E1/1.jpg" },
        {
          url: "img/FriendsPlus/Page40/E1/2.jpg",
          audioUrl: "img/FriendsPlus/Page40/Audio/tieude-e1-p40.mp3",
        },
        { url: "img/FriendsPlus/Page40/E1/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page40/E1/4.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page40/E1/5.jpg" },
        {
          url: "img/FriendsPlus/Page40/E1/6.jpg",
          audioUrl: "img/FriendsPlus/Page40/Audio/get up.mp3",
        },
        { url: "img/FriendsPlus/Page40/E1/7.jpg" },
        {
          url: "img/FriendsPlus/Page40/E1/8.jpg",
          audioUrl: "img/FriendsPlus/Page40/Audio/have breakfast.mp3",
        },
        { url: "img/FriendsPlus/Page40/E1/9.jpg" },
        {
          url: "img/FriendsPlus/Page40/E1/10.jpg",
          audioUrl: "img/FriendsPlus/Page40/Audio/go to school.mp3",
        },
        { url: "img/FriendsPlus/Page40/E1/11.jpg" },
        {
          url: "img/FriendsPlus/Page40/E1/12.jpg",
          audioUrl: "img/FriendsPlus/Page40/Audio/go home.mp3",
        },
        { url: "img/FriendsPlus/Page40/E1/13.jpg" },
        {
          url: "img/FriendsPlus/Page40/E1/14.jpg",
          audioUrl: "img/FriendsPlus/Page40/Audio/have dinner.mp3",
        },
        { url: "img/FriendsPlus/Page40/E1/15.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page40/E1/16.jpg" }],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 6",
    id: "SB3-U6-P40-E2",
    audio: "img/FriendsPlus/Page40/Audio/audio-e2-p40.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page40/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page40/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page40/Audio/tieude-e2-p40.mp3",
        },
        { url: "img/FriendsPlus/Page40/E2/3.jpg" },
      ],
      [
        // Column2
        { url: "img/FriendsPlus/Page40/E2/4.jpg" },
        {
          url: "img/FriendsPlus/Page40/E2/5.jpg",
          audioUrl: "img/FriendsPlus/Page40/Audio/get up.mp3",
        },
        { url: "img/FriendsPlus/Page40/E2/6.jpg" },
        {
          url: "img/FriendsPlus/Page40/E2/7.jpg",
          audioUrl: "img/FriendsPlus/Page40/Audio/have breakfast.mp3",
        },
        { url: "img/FriendsPlus/Page40/E2/8.jpg" },
        {
          url: "img/FriendsPlus/Page40/E2/9.jpg",
          audioUrl: "img/FriendsPlus/Page40/Audio/go to school.mp3",
        },
        { url: "img/FriendsPlus/Page40/E2/10.jpg" },
        {
          url: "img/FriendsPlus/Page40/E2/11.jpg",
          audioUrl: "img/FriendsPlus/Page40/Audio/go home.mp3",
        },
        { url: "img/FriendsPlus/Page40/E2/12.jpg" },
        {
          url: "img/FriendsPlus/Page40/E2/13.jpg",
          audioUrl: "img/FriendsPlus/Page40/Audio/have dinner.mp3",
        },
        { url: "img/FriendsPlus/Page40/E2/14.jpg" },
      ],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 6",
    id: "SB3-U6-P40-E3",
    audio: "img/FriendsPlus/Page40/Audio/audio-e3-p40.mp3",
    video: "Videos/e3.p40.mp4",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page40/E3/1.jpg" },
        { url: "img/FriendsPlus/Page40/E3/2.jpg", audioUrl: "img/FriendsPlus/Page40/Audio/tieude-e3-p40.mp3", },
        { url: "img/FriendsPlus/Page40/E3/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page40/E3/4.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page40/E3/5.jpg" },
        { url: "img/FriendsPlus/Page40/E3/6.jpg", audioUrl: "img/FriendsPlus/Page40/Audio/hinh1-e3-p40.mp3", },
        { url: "img/FriendsPlus/Page40/E3/7.jpg" },
        { url: "img/FriendsPlus/Page40/E3/8.jpg", audioUrl: "img/FriendsPlus/Page40/Audio/hinh2-e3-p40.mp3", },
        { url: "img/FriendsPlus/Page40/E3/9.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page40/E3/10.jpg" }],
      [
        // Column5
        { url: "img/FriendsPlus/Page40/E3/11.jpg" },
        { url: "img/FriendsPlus/Page40/E3/12.jpg", audioUrl: "img/FriendsPlus/Page40/Audio/hinh3-e3-p40.mp3", },
        { url: "img/FriendsPlus/Page40/E3/13.jpg" },
        { url: "img/FriendsPlus/Page40/E3/14.jpg", audioUrl: "img/FriendsPlus/Page40/Audio/hinh4-e3-p40.mp3", },
        { url: "img/FriendsPlus/Page40/E3/15.jpg" },
      ],
      
      [{ url: "img/FriendsPlus/Page40/E3/16.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page40/E3/17.jpg" },
        { url: "img/FriendsPlus/Page40/E3/18.jpg", audioUrl: "img/FriendsPlus/Page40/Audio/hinh5-e3-p40.mp3", },
        { url: "img/FriendsPlus/Page40/E3/19.jpg" },
        { url: "img/FriendsPlus/Page40/E3/20.jpg", audioUrl: "img/FriendsPlus/Page40/Audio/hinh6-e3-p40.mp3", },
        { url: "img/FriendsPlus/Page40/E3/21.jpg" },
      ],
    ],
  },
};

export default json;
